import type { AppearanceVariant } from '../types';
import { SimplePreview } from '../previews/simple';
import { SimpleNavigation } from './simple-navigation';
import { SimpleStart } from './simple-start';

export const simpleVariant: AppearanceVariant = {
  id: 'simple',
  nameKey: 'appearance.simple',
  descriptionKey: 'appearance.simpleDescription',
  className: 'erp-simple',
  composition: 'sidebar',
  groupedNavigation: true,
  documentEntry: 'guided',
  progressiveForms: true,
  Navigation: SimpleNavigation,
  Start: SimpleStart,
  Preview: SimplePreview,
};
